import { useState } from "#app";
export function useSessionState() {
  const user = useState("user", () => null);
  const session = useState("session", () => null);
  return {
    user,
    session
  };
}
export function useOrganizationState() {
  const activeOrganization = useState("activeOrganization", () => null);
  const activeMember = useState("activeMember", () => null);
  return {
    activeOrganization,
    activeMember
  };
}
